export const TimeDefaultFormat = "HH:mm";
export const DateDefaultFormat = "dd.MM.yyyy.";
export const DateTimeDefaultFormat = "dd.MM.yyyy. HH:mm";